export default "__VITE_ASSET__6070daa3__"